<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconMeetingRoom_16"
    viewBox="0 0 16 16"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        d="M13.5 2h-11A2.503 2.503 0 0 0 0 4.5v7C0 12.879 1.122 14 2.5 14h11c1.378 0 2.5-1.121 2.5-2.5v-7C16 3.121 14.878 2 13.5 2ZM8 4.387c1.269 0 2.3 1.032 2.3 2.3A2.303 2.303 0 0 1 8 8.988a2.304 2.304 0 0 1-2.301-2.301c0-1.268 1.032-2.3 2.301-2.3ZM11.709 13H4.291a.627.627 0 0 1-.62-.72c.112-.722.387-1 .547-1.174.596-.65 1.729-1.135 3.782-1.135 2.036 0 3.167.477 3.767 1.118.173.185.449.468.562 1.191a.628.628 0 0 1-.62.72Z"
    />
</svg>
